import fetchWrapper from '../fetchWrapper';

export default {
  getGroupStatus(groupId) {
    return fetchWrapper(`/nds/${groupId}`, {
      method: 'GET',
    }).then((resp) => resp.json());
  },
};
